import { createApp } from '@backstage/frontend-defaults';
import {
  AppRootElementBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { CssBaseline } from '@material-ui/core';
import { apiModules } from './apis';
import { navModule } from './components/Root';
import { entraSignInPage } from './components/auth/signInPage';
import { consentPage } from './components/auth/consentPageExtension';
import { entityExtensions } from './components/catalog/extensions';
import { formFieldExtensions } from './components/scaffolder/extensions';
import { toolsSearchResultType } from './components/search/extensions';
import { clearisticDarkTheme, clearisticLightTheme } from './themes/extensions';

/**
 * Everything the app itself contributes.
 *
 * Pages come from plugins, which are installed by feature discovery — see
 * `app.packages` in `app-config.yaml`. Nothing is imported here for that
 * purpose, including the three `@internal/plugin-*` ones.
 *
 * The extensions below all declare where they attach, so they can live in one
 * module for the `app` plugin regardless of which page they end up on. Route
 * bindings are not needed either: every external route ref these plugins use
 * carries a `defaultTarget`.
 */
const appModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    clearisticLightTheme,
    clearisticDarkTheme,
    entraSignInPage,
    consentPage,
    toolsSearchResultType,
    ...entityExtensions,
    ...formFieldExtensions,
    AppRootElementBlueprint.make({
      name: 'css-baseline',
      params: { element: <CssBaseline /> },
    }),
  ],
});

const app = createApp({
  features: [...apiModules, appModule, navModule],
});

export default app.createRoot();
